import { atom } from "recoil";

export const scenesState = atom({
  key: "scenesState",
  default: [],
});
